import { Card, CardContent, Skeleton, Stack } from '@mui/material';

export default function TimelineCardSkeleton() {
  return (
    <Card
      component="article"
      aria-hidden="true"
      data-testid="timeline-card-skeleton"
      variant="outlined"
      sx={(theme) => ({
        border: '1px solid',
        borderColor: theme.palette.grey[300],
        borderLeftWidth: 3,
        borderLeftColor: theme.palette.grey[400],
        borderRadius: 2,
        boxShadow: theme.shadows[1],
      })}>
      <CardContent sx={{ p: { xs: 1.5, sm: 2 } }}>
        <Stack spacing={1.5}>
          <Stack
            direction="row"
            flexWrap="wrap"
            justifyContent="space-between"
            alignItems="center"
            gap={1}>
            <Stack direction="row" spacing={0.75} alignItems="center">
              <Skeleton variant="rounded" width={48} height={24} />
              <Skeleton variant="rounded" width={104} height={24} />
              <Skeleton variant="rounded" width={92} height={24} />
            </Stack>
            <Skeleton variant="text" width={92} height={32} />
          </Stack>
          <Skeleton variant="text" width="34%" height={24} />
          <Stack spacing={1}>
            <Skeleton variant="text" width="58%" height={30} />
            <Skeleton variant="text" width="47%" height={20} />
          </Stack>
          <Stack spacing={0.25}>
            <Skeleton variant="text" width="100%" height={20} />
            <Skeleton variant="text" width="76%" height={20} />
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
